import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import I18n from "i18n-js";
import {parseTimeRange, SUBMISSION_LISTS_HOME_PICK_UP_TIME_RANGES} from "../../utils/utils";
import Address from "./Address";


const setShowPickUpRequestPopup = ({
  showPickUpRequestPopup,
  onShipmentManagementHandler,
  onCancel,
  setShowPickUpRequestPopup,
  submissionListToSend,
  productsCountToRequestPickUp,
  companyToRequestPickUp,
  graderCompanyShipmentAddress,
  homePickUpFavoriteDay,
  setHomePickUpFavoriteDay,
  homePickUpFavoriteHour,
  setHomePickUpFavoriteHour,
  homePickUpDates,
  currentUserGenerality
}) => {

  const [ invalidDay, setInvalidDay ] = useState(false);

  useEffect(() => {
    if (homePickUpFavoriteDay)
      setInvalidDay(!homePickUpDates.range.includes(homePickUpFavoriteDay));
  }, [homePickUpFavoriteDay]);



  // Funzione che gestisce la chiusura della modale
  const handleClose = () => {
    setShowPickUpRequestPopup(false);
  }


  // Funzione che gestisce il click sul tasto Conferma del popup
  const handleConfirm = () => {
    onShipmentManagementHandler(homePickUpFavoriteDay, homePickUpFavoriteHour);
    handleClose();
  }



  return (
    <Modal show={showPickUpRequestPopup} onHide={handleClose} animation={false} size="lg" centered>
      <Modal.Body>
        {
          submissionListToSend ?
            <span>
              {I18n.t('js.indexSubmissionListsPage.pickUpRequest.alert2') + submissionListToSend.number + '?'}
            </span>
          :
            productsCountToRequestPickUp >= companyToRequestPickUp.shipping_discount_products_threshold ?
              <div className="my-3">
                <p>
                  {I18n.t('js.common.hello')} {currentUserGenerality}!
                </p>
                <p>
                  {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg')}&nbsp;
                  {homePickUpDates.range_italian_format[0]}&nbsp;
                  {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg1')}&nbsp;
                  {homePickUpDates.range_italian_format[1]},&nbsp;
                  {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg2')}
                </p>
                <p className="my-4">
                  {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg3')}:
                </p>

                <div className="row">
                  <div className="col-12 col-sm-6 text-left border-right-solid mt-1 pt-2 pb-1">
                    <div className="row">
                      <div className="col-12 col-lg-6">
                        <div className="d-flex justify-content-start">
                          <small className="color-gray mr-2 mb-2">
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDayTitle').toUpperCase()}
                          </small>
                        </div>

                        <input
                          type="date"
                          className="form-control supplementary-item-form-input border-left-radius-3px-imp w-100"
                          name="favorite_day"
                          id="favorite_day"
                          min={homePickUpDates.range_iso_format[0]}
                          max={homePickUpDates.range_iso_format[1]}
                          onInput={(e) => setHomePickUpFavoriteDay(e.target.value)}
                        />
                      </div>
                    </div>

                    {
                      invalidDay &&
                        <div className="col-12 px-0 pt-1 text-aiBlue">
                          <i>{I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDateInvalidMessage')}</i>
                        </div>
                    }
                  </div>

                  <div className="col-12 col-sm-6 text-left mt-1 pt-2 pb-1">
                    <div className="row">
                      <div className="col-12 col-lg-6">
                        <div className="d-flex justify-content-start">
                          <small className="color-gray mr-2 mb-2">
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRange').toUpperCase()}
                          </small>
                        </div>

                        <select
                          className="form-control supplementary-item-form-input supplementary-item-form-select w-100"
                          name="favorite_hour"
                          id="favorite_hour"
                          onChange={(e) => setHomePickUpFavoriteHour(e.target.value)}
                        >
                          <option value="" id="no_hour">
                            {I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
                          </option>
                          {SUBMISSION_LISTS_HOME_PICK_UP_TIME_RANGES.map((time_range) =>(
                            <option value={time_range} id={`time_range_${time_range}`} key={`time_range_${time_range}`}>
                               {time_range !== 'all_day' ? parseTimeRange(time_range) : I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpAnyHour')}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            :
              <div className="my-3">
                <p>
                  {I18n.t('js.common.hello')} {currentUserGenerality}!
                </p>
                <p>
                  {
                    I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService1') + companyToRequestPickUp.shipping_discount_products_threshold +
                    I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService2') + ' ' + companyToRequestPickUp.meta_name + '.'
                  }
                </p>
                <p>
                  {I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService3')}
                </p>
                {
                  graderCompanyShipmentAddress &&
                  <React.Fragment>
                    <p className="my-4">
                      {I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService4')}
                    </p>
                    <Address
                      address={graderCompanyShipmentAddress}
                      renderResidence={false}
                    />
                  </React.Fragment>
                }
              </div>

        }
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
          onClick={onCancel ? () => onCancel() : handleClose}>
          {I18n.t('js.common.button.cancel').toUpperCase()}
        </button>
        <button
          type="button"
          className="btn-standard bg-aig-gradient color-white br-20px px-5 btn-standard-resized pt-4px-imp h-35px"
          disabled={companyToRequestPickUp && productsCountToRequestPickUp >= companyToRequestPickUp.shipping_discount_products_threshold && (invalidDay || !homePickUpFavoriteDay || !homePickUpFavoriteHour)}
          onClick={handleConfirm}
        >
          {
            submissionListToSend || productsCountToRequestPickUp >= companyToRequestPickUp.shipping_discount_products_threshold ?
              I18n.t('js.common.button.confirm').toUpperCase()
            :
              I18n.t('js.indexSubmissionListsPage.pickUpRequest.send').toUpperCase()
          }
        </button>

      </Modal.Footer>
    </Modal>
  )
}

export default setShowPickUpRequestPopup;